module.exports = __webpack_public_path__ + "img/facebook_white.c1a60579.svg";